import { useContext } from "react";
import AuthContext from "./context/auth/AuthContext";

const getPermission = (
  roleType,
  rolePermission,
  screen,
  actionType,
  clientId
) => {
  // console.log("usePermission props", roleType, rolePermission);
  // console.log("usePermission props", screen, actionType, clientId);

  // Add safety checks
  if (!rolePermission || !Array.isArray(rolePermission) || !screen || !actionType) {
    return false;
  }

  if (rolePermission) {
    if (roleType && (roleType.includes("Admin") || roleType.includes("Admin-PostAward") || roleType.includes("HierarchyAdmin") || roleType.includes("HierarchyAdmin-PostAward"))) {
      let acc;
      rolePermission.forEach((role) => {
        // console.log("usePermission merge", role, acc);
        if (role && role.permission && role.permission[screen] && role.permission[screen][actionType] !== undefined) {
          acc = acc || role.permission[screen][actionType];
        }
      });
      return acc;
    } else if (clientId) {
      let findRole = rolePermission.filter(
        (role) => role.customerId === parseInt(clientId)
      )[0];
      // console.log("usePermission merge", screen, clientId, findRole);
      return findRole !== undefined && findRole.permission && findRole.permission[screen] && findRole.permission[screen][actionType] !== undefined
        ? findRole.permission[screen][actionType]
        : false;
    } else {
      let acc;
      rolePermission.forEach((role) => {
        // console.log("usePermission merge", role, acc);
        if (role && role.permission && role.permission[screen] && role.permission[screen][actionType] !== undefined) {
          acc = acc || role.permission[screen][actionType];
        }
      });
      return acc;
    }
  } else {
    return "";
  }
};
export default function usePermission(screen, actionType, clientId) {
  const authContext = useContext(AuthContext);
  const { roleType, permission } = authContext;

  // Add safety checks for required parameters
  if (!screen || !actionType || !roleType || !permission) {
    return false;
  }

  // console.log("usePermission", screen, actionType, clientId);
  // let rolePermission = getRolePermission(roleType);
  let actionPermission = getPermission(
    roleType,
    permission,
    screen,
    actionType,
    clientId
  );

  return actionPermission;
}
